import React, { Component } from 'react'
import _ from 'lodash'


import { NESTED_SPEC_ORDER } from 'containers/Project/Specifications/constants.js'

import { updateModuleData } from 'helpers/specHelpers'
import ListSpec from 'containers/Project/ListSpec/index'
import T from 'i18n-react' 


class HorizontalTableSpec extends Component {
  genNestedTableStrings = (tableKey, rowObjects) => {
    const { moduleName } = this.props

    const order = NESTED_SPEC_ORDER[moduleName][tableKey]

    if (!rowObjects) return ""

    return rowObjects.map((rowObject) => {
      let rowString = []
      order.forEach((key) => {
          if(rowObject[key]) {
            rowString.push(`${T.translate(`project.spec.${moduleName}.${tableKey}.${key}`)}: ${rowObject[key]}`)
          }
      })
      return rowString.join("\n")
    })
  }

  getNestedTableKeys = () => {
    const { specModuleData } = this.props
    const row = specModuleData.modifiedValues.length > 0 ? specModuleData.modifiedValues[0] : []
    
    return Object.entries(row).filter(([ _, value ]) => {
      return Array.isArray(value)
    }).map((e) => e[0])
  }

  combineData = (dataArr) => {
    const returnObj = {}
    dataArr.forEach((data, idx) => {
      this.getNestedTableKeys().forEach((key) => {
        data[key] = this.genNestedTableStrings(key, data[key])
      })

      returnObj[idx] = {
        ...data
      }
    })

    return Object.values(returnObj)
  }

  render() {
    const {
      specModuleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
      moduleName,
      firstRowHeader
    } = this.props

    if(!specModuleData) return null

    const config = {
      customModuleNames: Object.fromEntries(this.getNestedTableKeys().map((key) => [key, key]))
    }

    const newModuleData = updateModuleData(_.cloneDeep(specModuleData), this.combineData)

    return (
      <ListSpec
        moduleName={ moduleName }
        moduleData={ newModuleData }
        isModifiedPage={ isModifiedPage }
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
        config={config}
        firstRowHeader={firstRowHeader}
      />
    )
  }
}

export default HorizontalTableSpec
